import React, {Component} from 'react';
import TableContent from '../../ContenidoTablas/Facturacion';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import EditarFacturacion from './EditarFacturacion';
import SolicitarFacturacion from './SolicitarFacturacion';
import {
    fetchFacturacion,
    fetchSolicitudesFacturacion,
    fetchProformas,
    fetchDocumentoDescargar
} from '../../../../actions';
import getHistorialMovPedidos from '../../../../utils/getHistorialMovPedidos';
import moment from 'moment';
import formatMoney from '../../../../utils/formatMoney';
import {FadeLoader} from 'react-spinners';
import Alert from '../../../../components/Alert';

import pdf from '../../../../images/pdf-v2.png';
import xml from "../../../../images/xml-v2.png";
import saveAs from "../../../../utils/downloadFile";

const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_CLIENTE = '2';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_MULTIPLE = '1';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL = '0';
const SIN_PAGINACION = 'N';
const CON_PAGINACION = 'N';
const PAGINA = '1';
const NUMERO_PAGINAS = '10';
const VACIO = '';
const MODAL_EDITAR_FACTURACION = 'EditarFacturacion';
const MODAL_SOLICITUD_FACTURACION = 'SolicitudFacturacion';
const VACIO_PATH = '0';

// <I 86111> ivelasquez 12/03/2021
const renderCeldaPDF = (item, that) => {
    if (item.tipoDoc.startsWith("F") || item.tipoDoc.startsWith("B")) {
        return <di>
            {
                <a onClick={() => {
                    that.onClickDescargar({
                        'ruc': item.rucEmisor,
                        'tipoDocumento': item.tipoSunat,
                        'serie': item.noFactu.substring(0, 4),
                        'numero': item.noFactu.substring(4, item.noFactu.length),
                        'tipoArchivo': 'PDF'
                    })
                }}><img alt='pdf' className='card-image' src={pdf} style={{cursor: 'pointer'}}/></a>
            }
        </di>
    } else {
        return <div/>
    }
};

const renderCeldaXml = (item, that) => {
    if (item.tipoDoc.startsWith("F") ||
        item.tipoDoc.startsWith("B")) {
        return <div>
            {
                <a onClick={() => {
                    that.onClickDescargar({
                        'ruc': item.rucEmisor,
                        'tipoDocumento': item.tipoSunat,
                        'serie': item.noFactu.substring(0, 4),
                        'numero': item.noFactu.substring(4, item.noFactu.length),
                        'tipoArchivo': 'XML'
                    });
                }}><img alt='xml' className='card-image' height={32} width={32} src={xml} style={{cursor: 'pointer'}}/></a>
            }
        </div>
    } else {
        return <div/>
    }
};

// <F 86111> ivelasquez 12/03/2021

class Facturation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowSelected: '',
            modalOpen: '',
            pedidosClienteFacturacion: [],
            pedidosConCheck: [],
            facturacionGrupo: [],
            solicitudfacturacion: [],
            muestraLoad: '',
            lstDocummentosVenta: [],
            lstHistorialPedido: [],
            lstMovimientosPagos: [],
        };
    }

    componentDidMount() {
        this.fnListadoPedidosFacturacion(this.props.fdvID);

    }

    // <I 86111> ivelasquez 12/03/2021
    showError(mensaje) {
        this.setState({
            muestraLoad: 'none',
            iconAlert: 'ion-close-circled',
            colorBackground: '#F56669',
            mensajeAlert: mensaje
        });
        setTimeout(() => {
            this.setState({muestraAlert:false})
        }, 3000)
    }

    onClickDescargar(params) {
        this.setState({muestraLoad: 'block'});
        this.props.fetchDocumentoDescargar(params).then((result) => {
            if (result.payload.data.estado === 1) {
                const fileName = params.ruc + "-" + params.tipoDocumento + "-" + params.serie + "-" + params.numero + "." + params.tipoArchivo.toLowerCase();
                const contentType = 'application/pdf';
                const b64Data = result.payload.data.fileBase64;
                if (params.tipoArchivo === 'PDF') {
                    //saveAs(b64Data, contentType, fileName);

                    const type = 'data:application/pdf;base64,' + b64Data;
                    const win = window.open();
                    win.document.write(
                        '<br><div style="float: right; margin-right: 20px;">' +
                        '<a href="' + type + '" download="' + fileName + '">' +
                        '<img alt="pdf" className="card-image" src="' + pdf + '"/>' +
                        '</a>' +
                        '</div>' +
                        '<br><br><br><iframe src="' + type + '" frameborder="0"'  +
                        'style="border: 0; top: 0; left: 0; bottom: 0;' +
                        'right: 0; width: 100%; height: 100%" allowfullscreen></iframe>'
                    );

                    this.setState({muestraLoad: 'none'});
                } else {
                    saveAs(b64Data, contentType, fileName);
                    this.setState({muestraLoad: 'none'});
                }
            } else {
                this.setState({muestraLoad: 'none'});
                this.setState({muestraAlert: true});
                this.showError(result.payload.data.mensaje)
            }
        }).catch(() => {
            this.setState({muestraLoad: 'none'});
            this.setState({muestraAlert: true});
            this.showError("Error interno en el servidor");
        });
    }

    // <F 86111> ivelasquez 12/03/2021

    loading = (status) => {
        this.setState({muestraLoad: status});
    }

    fnListadoPedidosFacturacion = (id) => {

        this.loading('block');
        const promises = [];

        promises.push(this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_MULTIPLE, CON_PAGINACION, PAGINA, NUMERO_PAGINAS));

        Promise.all(promises)
            .then((results) => {

                this.setState({
                    facturacionGrupo: results[0].payload.data.listado,
                });

                this.props.fetchSolicitudesFacturacion(id, VACIO_PATH, VACIO)
                    .then((result) => {

                        this.setState({solicitudfacturacion: result.payload.data});
                    }).catch((error) => {
                    console.log(error)
                });
                this.loading('none');
                this.loadPedidos();

            });

    }


    toggleRow = (index) => {
        if (index === this.state.rowSelected) {
            this.setState({rowSelected: ''});
        } else {
            this.setState({rowSelected: index});
        }
    }

    openModal = (modal) => {
        this.setState({modalOpen: modal});
    }

    closeModal = () => {
        this.setState({modalOpen: ''})
        this.fnListadoPedidosFacturacion(this.props.fdvID);
        this.fnSolicitudFacturacion(this.props.fdvID);
    }

    fnSolicitudFacturacion = (id) => {

        this.props.fetchSolicitudesFacturacion(id, VACIO_PATH, VACIO)
            .then((result) => {
                this.setState({solicitudfacturacion: result.payload.data});

            }).catch((error) => {
            console.log(error)
        });
    }

    loadPedidos = () => {

        getHistorialMovPedidos(this.props.fdvID, '', '', '', '123').then(entry => {
            this.setState({
                lstDocummentosVenta: entry.data.lstDocummentosVenta,
                lstHistorialPedido: entry.data.lstHistorialPedido,
                lstMovimientosPagos: entry.data.lstMovimientosPagos
            })
        });
    }

    render() {
        const {rowSelected} = this.state;
        return (
            <div>
                <section className='fdv-section' id='facturacionFDV'>
                    <header className='fdv-section-head'>
                        <h5 className='fdv-section-title'>Datos de facturación</h5>
                        <div className='fdv-section-actions'>
                            <button className='btn btn-primary btn-sm' data-toggle='modal'
                                    data-target='#fdv-editCliente' data-dismiss='modal'
                                    onClick={(e) => this.props.handlePermissions(e) && this.openModal(MODAL_EDITAR_FACTURACION)}
                                    data-permisos='ind_editar_datos_fact'>Editar datos
                            </button>
                        </div>
                    </header>
                    {
                        this.state.facturacionGrupo.map(facturacionGrupo => (
                            facturacionGrupo.desDocFact === null && facturacionGrupo.desTipoPago === null && facturacionGrupo.desEntidadFinan === null ? null : (
                                <div key={facturacionGrupo.numPedidoVeh}>
                                    <div className='card card-plain mb-3'>
                                        <h3 className='card-lg-title'>N° de pedidos</h3>
                                        <p className='h6'>{facturacionGrupo.numPedidoVeh}</p>
                                        <div className='row mt-2'>
                                            <div className='col-md-4'>
                                                <span className='labelInfo'>Cliente de facturación</span>
                                                <p>{facturacionGrupo.desClie}</p>
                                            </div>
                                            <div className='col-md-4'>
                                                <span className='labelInfo'>Cliente de propietario</span>
                                                <p>{facturacionGrupo.desPropietarioVeh}</p>
                                            </div>
                                            <div className='col-md-4'>
                                                <span className='labelInfo'>Cliente de usuario</span>
                                                <p>{facturacionGrupo.desUsuarioVeh}</p>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div className='row mt-2'>
                                            <div className='col-md-3'>
                                                <span className='labelInfo'>Documento</span>
                                                <p>{facturacionGrupo.desDocFact}</p>
                                            </div>
                                            <div className='col-md-3'>
                                                <span className='labelInfo'>Tipo de pago</span>
                                                <p>{facturacionGrupo.desTipoPago}</p>
                                            </div>
                                            <div className='col-md-3'>
                                                <span className='labelInfo'>Entidad financiera</span>
                                                <p>{facturacionGrupo.desEntidadFinan}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}
                    <header className='fdv-section-head'>
                        <h5 className='fdv-section-title'>Solicitudes realizadas</h5>
                        <div className='fdv-section-actions'>
                            <button
                                className='btn btn-primary btn-sm active'
                                data-toggle='modal'
                                data-target='#fdv-solicFact'
                                data-dismiss='modal'
                                show='#solicfacPed'
                                hide='#solicfacPedInfo'
                                onClick={(e) => this.props.handlePermissions(e) && this.openModal(MODAL_SOLICITUD_FACTURACION)}
                                fdvsolicfactslide='0'
                                data-permisos='ind_nueva_sol_fact'>Nueva Solicitud
                            </button>
                        </div>
                    </header>
                    <div className='tableWrapper hidden-xs'>
                        <table className='table table-hover table-accordion'>
                            <thead className='table-head'>
                            <tr>
                                <th>Pedido</th>
                                <th>Fecha</th>
                                <th>Documento</th>
                                <th>Tipo de solicitud</th>
                                <th>Tipo de pago</th>
                            </tr>
                            </thead>

                            <TableContent
                                rowSelected={rowSelected}
                                toggleRow={this.toggleRow}
                                fdvID={this.props.fdvID}
                                solicitudfacturacion={this.state.solicitudfacturacion}
                            />

                        </table>
                    </div>

                    <header className='fdv-section-head'>
                        <h5 className='fdv-section-title'>Documentos</h5>
                    </header>
                    <div className='tableWrapper hidden-xs'>
                        <table className='table table-hover'>
                            <thead className='table-head'>
                            <tr>
                                <th>Pedido</th>
                                <th colspan="2">Documento</th>
                                <th>Estado</th>
                                <th>Fecha</th>
                                <th>Moneda</th>
                                <th>Monto</th>
                                <th>Clase</th>
                                <th>Tipo</th>
                                <th colspan="2">Referencia</th>
                                <th colSpan="2">&nbsp;</th>{/* <86111> ivelasquez 12/03/2021 */}
                            </tr>
                            </thead>

                            <tbody>
                            {
                                this.state.lstDocummentosVenta.map((entity) =>
                                    <tr>
                                        <td>{entity.noOrdenDesc}</td>
                                        <td>{entity.tipoDoc}</td>
                                        <td>{entity.noFactu}</td>
                                        <td>{entity.estado}</td>
                                        <td>{moment(entity.fecha).format('DD/MM/YYYY')}</td>
                                        <td>{entity.moneda}</td>
                                        <td>{formatMoney(entity.valPreDocu)} </td>
                                        <td>{entity.tiFactura}</td>
                                        <td>{entity.parcial}</td>
                                        <td>{entity.docDevol}</td>
                                        <td>{entity.noDevol}</td>
                                        {/* <I 86111> ivelasquez 12/03/2021 */}
                                        <td>{renderCeldaXml(entity, this)}</td>
                                        <td>{renderCeldaPDF(entity, this)}</td>
                                        {/* <F 86111> ivelasquez 12/03/2021 */}
                                    </tr>
                                )
                            }
                            </tbody>


                        </table>


                    </div>

                    {
                        this.state.modalOpen === MODAL_EDITAR_FACTURACION ? (
                            <EditarFacturacion
                                closeModal={this.closeModal}
                                fdvID={this.props.fdvID}
                                loading={this.loading}
                                openAlert={this.props.openAlert}
                            />) : null
                    }

                    {
                        this.state.modalOpen === MODAL_SOLICITUD_FACTURACION ? (
                            <SolicitarFacturacion
                                closeModal={this.closeModal}
                                idFichaVenta={this.props.fdvID}
                                pedidos={this.state.pedidosClienteFacturacion}
                                loading={this.loading}
                                openAlert={this.props.openAlert}
                                llamadaProformaOrTabProforma={1}
                                whereRunTabOrProf={'1'}
                            />) : null
                    }


                </section>
                <div className='modal extraFilter' role='dialog' data-backdrop='static'
                     style={{display: this.state.muestraLoad}}>
                    <div className='modal-dialog modal-sm' role='document'>
                        <FadeLoader color={'#F8A14A'} loading/>
                    </div>
                </div>

                {
                    this.props.pedidos && this.props.pedidos.error ?
                        <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                            <p>Hubo un error con el servicio de listar pedidos</p>
                        </Alert> : null
                }

            </div>
        );
    }
}

Facturation.defaultProps = {
    facturacion: [],
};

function mapStateToProps(state) {
    return {
        pedidos: state.pedidos,
    };
}

export default withRouter(
    connect(mapStateToProps, {
        fetchFacturacion, fetchSolicitudesFacturacion, fetchProformas, getHistorialMovPedidos, fetchDocumentoDescargar
    })(Facturation));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Facturacion/index.js